import { useLocation } from "react-router-dom";
import {
  SidebarInset,
  SidebarProvider,
  useSidebar,
} from "@/core/components/ui/sidebar";
import { ROUTES } from "@/core/routes/constants";
import { WosSidebar } from "./components/wos-sidebar";
import { WosMobileHeader } from "./mobile/wos-mobile-header";

/**
 * Header mobile das telas comuns. O Centro de ações monta o próprio header,
 * porque o Trailing dele abre o histórico de IA (estado da página).
 */
function MobileShellHeader() {
  const { pathname } = useLocation();

  if (pathname.startsWith(ROUTES.ACTION_CENTER)) return null;

  return <WosMobileHeader />;
}

/** No mobile a navegação é o Header (hambúrguer) + a gaveta da sidebar. */
function ShellContent({ children }: { children: React.ReactNode }) {
  const { isMobile } = useSidebar();

  return (
    <SidebarInset className="h-svh overflow-hidden bg-background">
      {isMobile && <MobileShellHeader />}
      {children}
    </SidebarInset>
  );
}

/**
 * Shell WOS (PED-12262, Fase 1): sidebar nova + área de conteúdo.
 * A área reservada do painel do agente (Fase 3) será acoplada aqui.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-svh max-h-svh overflow-hidden">
      {/* Largura da Sidebar do Workbase DS (Figma 6051:2744): 256px. */}
      <SidebarProvider
        className="h-full"
        style={{ "--sidebar-width": "16rem" } as React.CSSProperties}
      >
        <WosSidebar />

        {/* O scroll vive dentro do contêiner arredondado de cada página
            (AppContent), para os cantos de raio 32 ficarem fixos na viewport. */}
        <ShellContent>{children}</ShellContent>
      </SidebarProvider>
    </div>
  );
}
